module.exports = __webpack_public_path__ + "static/media/43.31ceb9ce.svg";


//////////////////
// WEBPACK FOOTER
// ./src/css/img/newWeatherIcons/43.svg
// module id = 2835
// module chunks = 3